module.exports = __webpack_public_path__ + "img/pleisure_bodyimage04-3.37c29666.jpg";